import axios from 'axios'
import config from '../config'
import {getDoctorToken} from '../utils'

const updateDoctorDetailApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}doctor`,
        method: "put",
        data:params,

        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`

           
        }
    })

    return response

}

export default updateDoctorDetailApi